import { useState } from 'react';
import { useSelector } from 'react-redux';
import Loader from '@rsos/components/capstone/Loader';
import { Box } from '@rsos/components/capstone/base';
import {
  THIRTY_DAYS,
  useGetHistoricConversationsQuery,
} from '@rsos/reduxDataStore/src/features/textFrom911/textFrom911Api';
import { selectUserOrgByApp } from '@rsos/sinatra';
import { SearchCommunicationWrapper } from './SearchCommunicationWrapper';
import { NoResults } from './styles/CommunicationHistoryTableContainer.styles';

const CommunicationContainer = () => {
  const [historicStartTime] = useState(new Date().getTime() - THIRTY_DAYS);
  const [historicEndTime] = useState(new Date().getTime());

  const orgName = useSelector(
    state =>
      selectUserOrgByApp(
        state.sinatra,
        state.sinatra.user.currentRole.application,
      ).name,
  );

  const historicConversationsResult = useGetHistoricConversationsQuery({
    orgName,
    startTime: historicStartTime,
    endTime: historicEndTime,
  });
  return historicConversationsResult.status === 'pending' ? (
    <NoResults>
      <Box align="center" justify="center">
        <Loader />
      </Box>
    </NoResults>
  ) : historicConversationsResult.data &&
    historicConversationsResult.data.length ? (
    <SearchCommunicationWrapper data={historicConversationsResult.data} />
  ) : (
    <NoResults>
      <Box align="center" justify="center">
        No results found
      </Box>
    </NoResults>
  );
};

export default CommunicationContainer;
